// src/api/payments.api.js
import axiosInstance from './axiosInstance';

/**
 * إضافة دفعة لحجز
 * @param {{ booking: number, amount: number, payment_date: string, notes?: string }} payload
 */
export const createPayment = (payload) =>
  axiosInstance.post('/payments/', payload);

/**
 * حذف دفعة
 * @param {number} id
 */
export const deletePayment = (id) =>
  axiosInstance.delete(`/payments/${id}/`);